import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-694fac1d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "mydiv",
  class: "w-100 h-100"
}
const _hoisted_2 = { style: {"margin-left":"1%"} }
const _hoisted_3 = {
  class: "stationCodeDiv0",
  style: {"text-align":"left"}
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div style=\"width:100%;\" data-v-694fac1d><table id=\"tblstationCode\" style=\"width:calc(100% - 16px);\" data-v-694fac1d><thead data-v-694fac1d><tr data-v-694fac1d><th style=\"width:8%;\" data-v-694fac1d>Station Code</th><th style=\"width:20%;\" data-v-694fac1d>Company&#39;s Name</th><th style=\"width:8%;\" data-v-694fac1d>3 Digit Code</th><th style=\"width:8%;\" data-v-694fac1d>Parent Code</th><th style=\"width:16%;\" data-v-694fac1d>Country</th><th style=\"width:16%;\" data-v-694fac1d>Area</th><th style=\"width:8%;\" data-v-694fac1d></th><th style=\"width:8%;\" data-v-694fac1d></th></tr></thead></table></div>", 1)
const _hoisted_5 = {
  key: 1,
  style: {"text-align":"center","height":"calc(96% - 200px)"}
}
const _hoisted_6 = {
  key: 2,
  id: "tblbodydiv",
  style: {"height":"calc(96% - 200px)","overflow":"auto"}
}
const _hoisted_7 = { id: "tblstationCode" }
const _hoisted_8 = { id: "tbltbody" }
const _hoisted_9 = { style: {"width":"8%"} }
const _hoisted_10 = { style: {"width":"20%"} }
const _hoisted_11 = { style: {"width":"8%"} }
const _hoisted_12 = { style: {"width":"8%"} }
const _hoisted_13 = { style: {"width":"16%"} }
const _hoisted_14 = { style: {"width":"16%"} }
const _hoisted_15 = { style: {"text-align":"center","width":"8%"} }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { style: {"text-align":"center","width":"8%"} }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-none" }, [
  /*#__PURE__*/_createElementVNode("button", {
    id: "showConfirmModal",
    "data-bs-toggle": "modal",
    "data-bs-target": "#showModal"
  })
], -1 /* HOISTED */))
const _hoisted_20 = {
  class: "modal fade",
  id: "showModal",
  tabindex: "-1",
  "aria-labelledby": "showModalLabel",
  "aria-hidden": "true",
  style: {"width":"35%","margin-left":"32.5%"}
}
const _hoisted_21 = {
  class: "modal-dialog modal-dialog-scrollable modal-lg",
  style: {"height":"auto"}
}
const _hoisted_22 = { class: "modal-content" }
const _hoisted_23 = { class: "modal-header" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", {
  class: "modal-title",
  id: "showModalLabel"
}, "Delete Station Code", -1 /* HOISTED */))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "modal-body",
  id: "modal-body",
  style: {"text-align":"left","font-size":"16px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { style: {"height":"20%"} }, " Are you sure to delete this station code? ")
], -1 /* HOISTED */))
const _hoisted_26 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.isLoading)
      ? (_openBlock(), _createBlock($setup["Loading"], {
          key: 0,
          isLoading: $setup.isLoading
        }, null, 8 /* PROPS */, ["isLoading"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["Alert"], {
        alertMessage: $setup.alertMessage,
        alertState: $setup.alertState
      }, null, 8 /* PROPS */, ["alertMessage", "alertState"])
    ]),
    _createVNode($setup["AdminNavigation"], { menuTile: $setup.title }, null, 8 /* PROPS */, ["menuTile"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", {
        style: {"cursor":"pointer","color":"blue","text-decoration":"underline"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.addStationCode()))
      }, "Add new station code")
    ]),
    _hoisted_4,
    ($setup.stationCodeListInfo.length == 0 && $setup.getData)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_5, " No data "))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _createElementVNode("tbody", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stationCodeListInfo[0], (info, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_9, _toDisplayString(info.stationCode), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(info.companyName), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(info.digit3_cd), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(info.parentCode), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(info.country), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(info.area), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_15, [
                    _createElementVNode("a", {
                      class: "btn btn-primary button-design-scanStation",
                      onClick: ($event: any) => (
                  $setup.editStationCode(
                    info.stationCode,
                    info.companyName,
                    info.digit3_cd,
                    info.parentCode,
                    info.countryCode,
                    info.areaCode
                  )
                )
                    }, " Edit ", 8 /* PROPS */, _hoisted_16)
                  ]),
                  _createElementVNode("td", _hoisted_17, [
                    _createElementVNode("button", {
                      class: "btn btn-primary button-design-scanStation",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#showModal",
                      onClick: ($event: any) => ($setup.rowParam(info.stationCode))
                    }, " Delete ", 8 /* PROPS */, _hoisted_18)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ])),
    _hoisted_19,
    _createCommentVNode(" Modal "),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.clearModalData()))
            })
          ]),
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("button", {
              type: "button",
              id: "modalCancel",
              class: "btn btn-secondary",
              style: {"width":"78px","height":"35px","text-align":"center"},
              "data-bs-dismiss": "modal",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.clearModalData()))
            }, " Cancel "),
            _createElementVNode("button", {
              type: "button",
              id: "btnDelete",
              class: "btn btn-primary button-design",
              style: {"width":"78px","height":"35px","text-align":"center"},
              "data-bs-dismiss": "modal",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.deleteStationCode($setup.modalStationCode)))
            }, " Delete ")
          ])
        ])
      ])
    ])
  ]))
}